import { createContext } from 'react';

export const FetchTaxAndPensionsInfoContext = createContext<Record<string, any>>({});
export const { Provider: FetchTaxAndPensionsInfoProviderWrapper } = FetchTaxAndPensionsInfoContext;
